import React, { useEffect, useState } from "react";
import { fetchApi, getUploadsUrl } from "../../config";

const TAGS = [
    { ico: "ti-php", short: "php", label: "PHP & Laravel" },
    { ico: "ti-react", short: "R", label: "React" },
    { ico: "ti-node", short: "N", label: "Node.js" },
    { ico: "ti-wp", short: "W", label: "WordPress" },
    { ico: "ti-angular", short: "A", label: "Angular" },
    { ico: "ti-ionic", short: "I", label: "Ionic" },
    { ico: "ti-woo", short: "Wc", label: "WooCommerce" },
    { ico: "ti-sass", short: "S", label: "Sass" },
];

export default function Toolkit() {
    const [tech, setTech] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        let mounted = true;
        async function load() {
            setLoading(true);
            try {
                const res = await fetchApi("get_technologies.php");
                if (!mounted) return;
                if (res && Array.isArray(res.Technologies)) {
                    setTech(res.Technologies);
                } else {
                    setTech([]);
                }
            } catch (err) {
                if (!mounted) return;
                setError(err.message || "Failed to load technologies");
            } finally {
                if (!mounted) return;
                setLoading(false);
            }
        }
        load();
        return () => { mounted = false; };
    }, []);

    const renderContent = () => {
        if (loading) return <p>Loading technologies…</p>;
        if (error) return <p className="form-note">Error: {error}</p>;
        const list = Array.isArray(tech) && tech.length ? tech : TAGS;
        return (
            <div className="tags">
                {list.map((t) => {
                    if (t.featureimage_url) {
                        const src = getUploadsUrl('technologies', t.featureimage_url);
                        return (
                            <span className="tag" key={t.id || t.name}>
                                <img src={src} alt={t.name || t.featureimage_name || "tech"} />
                                {/* {t.name} */}
                            </span>
                        );
                    }
                    return (
                        <span className="tag" key={t.label || t.name}>
                            <span className={`tag-ico ${t.ico || ''}`}>{t.short || (t.name && t.name[0].toUpperCase()) || ''}</span>
                            {/* {t.label || t.name} */}
                        </span>
                    );
                })}
            </div>
        );
    };

    return (
        <section className="container tech">
            <div className="eyebrow">Our toolkit</div>
            <h2 className="h-md">Modern technologies, chosen to fit — not to impress.</h2>
            {renderContent()}
        </section>
    );
}
